import { render } from "./MinisterList.vue?vue&type=template&id=70e4ff74&scoped=true&ts=true"
import script from "./MinisterList.ts?vue&type=script&lang=ts"
export * from "./MinisterList.ts?vue&type=script&lang=ts"

import "./MinisterList.scss?vue&type=style&index=0&id=70e4ff74&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e4ff74"]])

export default __exports__